<template>
  <!-- Where you stand in the pool this week (utils/poolCrowd.js
       liveStandings): before it, with the finals counted, and the projected
       finish once every open game is played out. -->
  <section class="mb-3 rounded-2xl border border-white/10 bg-brand-navy/40 px-3.5 py-3 shadow-lg shadow-black/15" aria-label="Your pool standing">
    <div class="flex items-baseline justify-between gap-2">
      <h2 class="text-[15px] font-extrabold text-white">Pool standing</h2>
      <span class="text-[10px] font-bold text-slate-400">{{ subtitle }}</span>
    </div>
    <div class="mt-2.5 grid grid-cols-3 gap-2">
      <div>
        <p class="label">{{ baselineWeek ? `WEEK ${baselineWeek}` : "START" }}</p>
        <p class="big text-slate-300">{{ baselineRank(me) }}</p>
        <p class="sub">{{ baselineRecord(me) }}</p>
      </div>
      <div>
        <p class="label">RIGHT NOW</p>
        <p class="big whitespace-nowrap text-white">
          {{ rankLabel(me.now) }}
          <span v-if="moved" class="text-xs" :class="moved > 0 ? 'text-emerald-400' : 'text-rose-400'">{{ moved > 0 ? "▲" : "▼" }}{{ Math.abs(moved) }}</span>
        </p>
        <p class="sub">{{ recordLabel(me.now) }}</p>
      </div>
      <div>
        <p class="label">{{ standings.openGames ? "PROJECTED" : "UNOFFICIAL" }}</p>
        <p class="big text-brand-green">{{ standings.openGames ? me.projected.median : rankLabel(me.now) }}</p>
        <p class="sub">{{ rangeLabel }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import { baselineRank, baselineRecord, rankLabel, recordLabel } from "@/utils/poolCrowd.js";

export default {
  name: "PoolStandingCard",
  props: {
    // liveStandings output, with a `me` row.
    standings: { type: Object, required: true },
    baselineWeek: { type: Number, default: null },
  },
  computed: {
    me() {
      return this.standings.me;
    },
    moved() {
      return this.me.hasBaseline ? this.me.before.rank - this.me.now.rank : 0;
    },
    subtitle() {
      const live = this.standings.liveGames;
      return `${this.standings.fieldSize} players${live ? ` · ${live} live` : ""}`;
    },
    rangeLabel() {
      if (!this.standings.openGames) return "all games final";
      const { low, high } = this.me.projected;
      return low === high ? "locked in" : `range ${low}–${high}`;
    },
  },
  methods: { baselineRank, baselineRecord, rankLabel, recordLabel },
};
</script>

<style scoped>
.label { font-size: 9px; font-weight: 800; letter-spacing: 0.14em; color: #94a3b8; }
.big { margin-top: 0.125rem; font-size: 22px; line-height: 1.15; font-weight: 900; letter-spacing: -0.03em; font-variant-numeric: tabular-nums; }
.sub { font-size: 10px; font-weight: 700; color: #64748b; }
</style>
